/**
 * Converts a Blob to a Uint8Array.
 * Reads the entire Blob into memory as a byte array.
 *
 * @param blob - The Blob to convert
 * @returns A promise that resolves to a Uint8Array containing the Blob's data
 *
 * @example
 * ```ts
 * import { BlobToUint8 } from "@pdfking/tfunc"
 *
 * const blob = new Blob(["Hello"], { type: "text/plain" });
 * const bytes = await BlobToUint8(blob);
 * console.log(bytes); // Uint8Array [72, 101, 108, 108, 111]
 *
 * // Use for hashing
 * const hash = await UInt8Hash([await BlobToUint8(blob)]);
 * ```
 */
export const BlobToUint8 = async (blob: Blob): Promise<Uint8Array> =>
  blob.arrayBuffer().then(b => new Uint8Array(b))
